import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form", "searchButton"];

  connect() {
    this.disableSearchButton(); // Initial check
  }

  submitSearch(event) {
    event.preventDefault();

    // Get the region input value
    const searchInput = document.querySelector(
      '[data-region-search-target="input"]'
    );

    let searchSlug = ""

    if(searchInput){
      if(searchInput.dataset.selectedResultType === "hotel"){
        searchSlug = searchInput.dataset.selectedHotelSlug;
      } else if(searchInput.dataset.selectedResultType === "region"){
        searchSlug = searchInput.dataset.selectedRegionSlug;
      }
    }
    
    if (!searchSlug) {
      import("./notification_controller").then((module) => {
        const NotificationController = module.default;
        NotificationController.show("Please select a destination or property", "error");
      });
      return;
    }

    let checkin = "";
    let checkout = "";

    try {
      const checkinInput = document.querySelector('input[name="checkin"]');
      const checkoutInput = document.querySelector('input[name="checkout"]');

      checkin = checkinInput ? checkinInput.value : "";
      checkout = checkoutInput ? checkoutInput.value : "";

      console.log("Checkin value:", checkin);
      console.log("Checkout value:", checkout);
    } catch (error) {
      console.error("Error getting date values:", error);
    }

    const adultsInput = document.getElementById("adults-input");
    const childrenInput = document.getElementById("children-input");
    const roomsInput = document.getElementById("rooms-input");

    const adults = adultsInput ? adultsInput.value : "1";
    const children = childrenInput ? childrenInput.value : "0";
    const rooms = roomsInput ? roomsInput.value : "1";

    // Build query parameters
    let queryParams = new URLSearchParams();
    if (checkin) queryParams.append("checkin", checkin);
    if (checkout) queryParams.append("checkout", checkout);
    if (adults) queryParams.append("adults", adults);
    if (children) queryParams.append("children", children);
    if (rooms) queryParams.append("rooms", rooms);

    let childAges = [];
    if (parseInt(children) > 0) {
      const childAgeInputs = document.querySelectorAll(
        'input[name^="child_age"]'
      );
      childAgeInputs.forEach((input) => {
        childAges.push(input.value);
        queryParams.append(input.name, input.value);
      });
    }

    let url;
    if(searchInput.dataset.selectedResultType === "hotel"){
      const regionSlug = searchInput.dataset.selectedRegionSlug;
      url = `/${regionSlug}/${searchSlug}?${queryParams.toString()}`;
    } else {
      url = `/${searchSlug}/hotels?${queryParams.toString()}`;
    }

    const canUpdateStorage = (document.body.dataset.page === "hotels/index") && ((checkin && checkout) || parseInt(adults) != 2 || parseInt(children) != 0 || parseInt(rooms) != 1 || childAges.length != 0)
    if(canUpdateStorage){
      this.setLocalStorage(checkin, checkout, parseInt(adults), parseInt(children), parseInt(rooms), childAges.map((age) => parseInt(age)));
    }

    window.location.href = url;
  }

  setLocalStorage(checkin, checkout, adults, children, rooms, childAges) {
    localStorage.setItem('search_form_state', JSON.stringify({
      dateRange: {
        start: checkin,
        end: checkout
      },
      adultCount: adults,
      childrenCount: children,
      roomsCount: rooms,
      childrenAges: childAges
    }));
  }

  disableSearchButton() {
    const regionInput = document.querySelector('[data-region-search-target="input"]');

    const regionSlug = regionInput ? regionInput.value : ""; // get the slug

    const searchButton = this.searchButtonTarget; // Use the target defined in static targets
    
    if (searchButton) {
      if (regionSlug && !this.isAgeMissing()) {
        searchButton.removeAttribute("disabled"); // Enable button
      } else {
        searchButton.setAttribute("disabled", "true"); // Disable button
      }
    }
  }

  isAgeMissing() {
    const childrenInput = document.getElementById("children-input");
    const children = childrenInput ? childrenInput.value : "0";
    const childrenCount = parseInt(children);
    const childrenAges = Array.from(document.querySelectorAll('[id^="child-age-"]')).map((a) => parseInt(a.value))

    if (childrenCount > 0) {
      return !(childrenAges.length === childrenCount && childrenAges.every(age => age > 0));
    } else {
      return false;
    }
  }
}
